module.exports = __webpack_public_path__ + "img/reply-20.0096959c.png";